import { render } from "./approve-reject-signup-modal.html?vue&type=template&id=f757f5f0&scoped=true&ts=true&external"
import script from "./approve-reject-signup-modal.ts?vue&type=script&lang=ts&external"
export * from "./approve-reject-signup-modal.ts?vue&type=script&lang=ts&external"

import "./approve-reject-signup-modal.scss?vue&type=style&index=0&id=f757f5f0&scoped=true&lang=sccs&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f757f5f0"]])

export default __exports__